import { useMemo } from 'react';

import { useAllowed } from '@shared';

type ItemType<T extends {}> = AccessProps & T;

export const useCheckAccess = <T extends {}>(items: ItemType<T>[]) => {
  const actions = useMemo(() => items.map(item => item.action), [items]);
  const allowed = useAllowed(actions);

  return useMemo(() => {
    const set = new Set(allowed);
    return items.filter(item => !item.action || set.has(item.action));
  }, [items, allowed]);
};
